import { createActions } from '@manager-base/app-base/config/data-access';
import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';

const actions = {
    getAll: {
        method: 'GET',
        url: `${BASE_PATH_API}/applicationGroups`,
        params: {
            '$count': true
        }
    },
    createApplicationGroup: {
        method: 'POST',
        url: `${BASE_PATH_API}/applicationGroups`
    },
    updateApplicationGroup: {
        method: 'PUT',
        url: `${BASE_PATH_API}/applicationGroups/:groupId`
    },
    getApplicationGroup: {
        method: 'GET',
        url: `${BASE_PATH_API}/applicationGroups/:groupId`
    },
    getApplicationGroupV2: {
        method: 'GET',
        url: `${BASE_PATH_API}/applicationGroups/v2/:groupId`
    },
    getApplicationGroupV3: {
        method: 'GET',
        url: `${BASE_PATH_API}/applicationGroups/v3/:groupId`
    },
    getNumberOfApplicantsInGroup: {
        method: 'GET',
        url: `${BASE_PATH_API}/applicationGroups/:groupId/applicants/count`
    },
    updateApplicationGroupProperty: {
        method: 'PATCH',
        url: `${BASE_PATH_API}/applicationGroups/:groupId/property`
    },
    deleteGroup: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/applicationGroups/:groupId`
    },
    updateApplicationGroupStatus: {
        method: 'PATCH',
        url: `${BASE_PATH_API}/applicationGroups/:groupId/status`
    },
    getApplicationGroups: {
        method: 'GET',
        url: `${BASE_PATH_API}/applicationGroups/summary`
    },
    removeApplicantsFromGroup: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/v3/applicationGroups/:groupId/applicants?applicantIds=:applicantIds`
    }
};

export function ApplicationGroupsApi() {
    return createActions(actions);
}
